import React from 'react'
import ModalsController from './../shared/Modals.controller'
import LoadingSpinner from './../../shared/LoadingSpinner.component'
import CustomModal from '../CustomModal/CustomModal.component' // Import your custom modal
import CareerRequestForm from './../../newhome/RequestForm.career'
import './CareerRequestModal.component.scss'

const MODAL_ID = 'modals.career-request',
  MODAL_BODY_CLASS = 'career-modal-open'

class CareerRequestModal extends React.Component {
  state = {
    isLoading: false,
    isOpen: false,
  }

  _ = null

  _open = () => this.setState({ isOpen: true })

  _isOpen = () => this.state.isOpen === true

  _isAutoOpen = () => this._.params(MODAL_ID, 'autoOpen') !== false

  _close = () => {
    if (typeof this.props?.onClose === 'function') this.props.onClose()
  }

  componentDidMount() {
    this._ = ModalsController.init(MODAL_ID, {
      autoOpen: !isNaN(this.props?.autoOpen) && this.props.autoOpen > 0 ? parseInt(this.props.autoOpen) : false,
      bodyClass: MODAL_BODY_CLASS,
    })
  }

  render() {
    return (
      <CustomModal
        isOpen={this.props.isOpen}
        onClose={this._close}
        title='Get More Info!'
        modalId='CareerRequestModalComponent'
        size='lg'
      >
        <div className='modal-body-content'>
          {this.state.isLoading ? (
            <div className='loading-wrapper'>
              <LoadingSpinner size='md' isActive={true} />
            </div>
          ) : (
            <CareerRequestForm onSuccess={this._close} />
          )}
        </div>
      </CustomModal>
    )
  }
}

export default CareerRequestModal
